const SearchIcon = () => {

    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.1455 14.2228C17.2328 12.7425 17.875 10.915 17.875 8.9375C17.875 4.00146 13.8735 0 8.9375 0C4.00146 0 0 4.00146 0 8.9375C0 13.8735 4.00146 17.875 8.9375 17.875C10.9156 17.875 12.7435 17.2324 14.224 16.1446L14.2228 16.1455C14.2634 16.2005 14.3086 16.2531 14.3583 16.3029L19.6527 21.5973C20.1897 22.1342 21.0603 22.1342 21.5973 21.5973C22.1342 21.0603 22.1342 20.1897 21.5973 19.6527L16.3029 14.3583C16.2531 14.3086 16.2005 14.2634 16.1455 14.2228ZM16.5 8.9375C16.5 13.1142 13.1142 16.5 8.9375 16.5C4.76085 16.5 1.375 13.1142 1.375 8.9375C1.375 4.76085 4.76085 1.375 8.9375 1.375C13.1142 1.375 16.5 4.76085 16.5 8.9375Z" fill="currentColor" />
        </svg>
    )
}

export default SearchIcon;